import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { RadioStyle } from "@insite/mobius/Radio";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

configureBudgetStyles.budgetYearEndDatePicker = {
    cssOverrides: {
        formField: css`
            position: relative;
            label {
                position: absolute;
                z-index: 1;
                left: 20px;
                background: #fff;
                width: auto;
                top: 0px;
                min-height: auto;
                & + div {
                    input,
                    select,
                    textarea {
                        background: #fff !important;
                        border-width: 1px !important;
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: auto;
                        margin-right: 35px;
                        margin-top: 15px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                        margin-top: 15px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                ])}
        `,
    },
    labelProps: {
        css: css`
            margin-bottom: 3px;
        `,
    },
};
configureBudgetStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: flex-start;
                `,
                css`
                    justify-content: flex-start;
                `,
                css`
                    justify-content: flex-end;
                    > button:first-child {
                        padding: 10px 14px;
                    }
                    > button:last-child {
                        padding: 0 14px;
                    }
                `,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
            ])}
    `,
};
configureBudgetStyles.enforcementLevelLabel = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin-right: 6px;
        color: #333;
    `,
};

configureBudgetStyles.budgetPeriodTitle = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin-right: 6px;
        color: #333;
        & + div[class^="TooltipWrapper"] {
            top: 4px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 60%;
                    `,
                    null,
                    null,
                ],
                "minMax",
            )}
    `,
};
configureBudgetStyles.budgetYearGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
        > div {
            min-width: 15%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 25%;
                    `,
                    null,
                    null,
                ])}
        }
    `,
};

configureBudgetStyles.gridItems = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        table {
                            tr {
                                th {
                                    padding: 0;
                                }
                                td {
                                    padding: 0 10px;
                                }
                            }
                        }
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

configureBudgetStyles.startDateHeader = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-left: 10px !important;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

configureBudgetStyles.periodHeader = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-left: 10px !important;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

configureBudgetStyles.budgetYearEndGridItem = {
    width: 12,
    css: css`
        > div {
            margin-top: 30px;
            &[data-test-selector="budgetPeriodTypeRadio"] {
                margin-top: 3px;
            }
            legend {
                font-size: 20px;
                font-weight: 700;
                color: #333;
                margin-bottom: 30px !important;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: block;
                    > div {
                        margin-top: 0;
                        &[data-test-selector="budgetPeriodTypeRadio"] {
                            margin-top: 0;
                        }
                    }
                `,
                css`
                    display: block;
                    > div {
                        margin-top: 0;
                        &[data-test-selector="budgetPeriodTypeRadio"] {
                            margin-top: 0;
                        }
                    }
                `,
                css`
                    display: flex;
                `,
                css`
                    display: flex;
                `,
                css`
                    display: flex;
                `,
            ])}
    `,
};
